module.exports = __webpack_public_path__ + "static/media/bgfiltered.bcde0dfb.png";